import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg viewBox="0 0 20 16" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M20 0H0v15.333h20V0zm-1.385 1.022L10 8.766 1.41 1.022h17.205zm-17.59 13.29V2.07L10 10.146l8.974-8.05V14.31H1.026z" fill="currentColor" /></svg>);